module.exports = __webpack_public_path__ + "img/ActivateCard.e703129f.jpg";